import { Row, Col, GRID } from '../../components/custom';

import firstImage from '../../images/sample/EJI/one.webp';
import secondImage from '../../images/sample/EJI/two.webp';
import thirdImage from '../../images/sample/EJI/three.webp';
import fourthImage from '../../images/sample/EJI/four.webp';
import fifthImage from '../../images/sample/EJI/five.webp';

export default function EJI()
{
    return (
        <Col id='EJI'>
            <Col className='banner'>
                <span className='title'>Visual Stories from Voice of Employees</span>
            </Col>
            <Col className='section' data-id='1'>
                <span className='title'>Favorable scores and mean ratings by engagement drivers</span>
                <span className='desc'>Strong on tools and managerial support but losing ground on career growth, recognition, and employee voice.</span>
                <img src={firstImage} alt='firstImage'/>
                <span className='descsmall'><strong>Favorable %</strong> : Rating of 4 or 5 on a 5-point scale.</span>
                <span className='descsmall'><strong>Tools and Resources.</strong> This is a <strong>clear organizational strength</strong> with favorable scores soaring above 85%, and average ratings nearing or surpassing 4.0. It suggests that employees feel well-equipped to do their jobs, with minimal friction from technology or infrastructure.</span>
                <span className='descsmall'>The most <strong>pressing concern</strong> is around <strong>Career Path</strong>. Favorability scores are alarmingly low, hovering around 30-38% across all 3 teams.</span>
            </Col>
            <Col className='section' data-id='2'>
                <span className='title'>Correlation heatmap</span>
                <span className='desc'>Managerial support, recognition, communication, and leadership trust move together.</span>
                <Row className='container'>
                    <img src={secondImage} alt='secondImage'/>
                    <GRID>
                        <span className='descsmall bold'>Driver Pair</span>
                        <span className='descsmall bold'>Correlation</span>
                        <span className='descsmall bold'>Insights</span>
                        <span className='descsmall'>Recognition & Manager Support</span>
                        <span className='descsmall'>~0.83</span>
                        <span className='descsmall'>Employees who feel recognized often perceive strong managerial support.</span>
                        <span className='descsmall'>Trust in Leadership & Communication</span>
                        <span className='descsmall'>~0.81</span>
                        <span className='descsmall'>Trust builds when leadership communicates clearly and frequently.</span>
                        <span className='descsmall'>Manager Support & Valued Opinions</span>
                        <span className='descsmall'>~0.79</span>
                        <span className='descsmall'>When managers support employees, their opinions are more likely to be heard</span>
                    </GRID>
                </Row>
            </Col>
            <Col className='section' data-id='3'>
                <span className='title'>Driver Analysis: Impact on Overall Engagement</span>
                <span className='desc'><strong>Recognition for contributions</strong> is the <strong>strongest predictor</strong> of overall engagement (β = 0.42)</span>
                <Row className='container'>
                    <Col>
                        <span className='descsmall'><strong>Recognition for contributions</strong> is the <strong>strongest predictor</strong>, but it currently has <strong>below-average ratings</strong>, indicating a <strong>critical opportunity area.</strong></span>
                        <span className='descsmall'><strong>Career path clarity</strong> and <strong>trust in leadership</strong> are also <strong>high-impact drivers</strong> with room for improvement.</span>
                        <span className='descsmall'><strong>Work-life balance</strong> and <strong>manager support</strong> have <strong>moderate influence</strong>, suggesting targeted interventions may enhance their impact.</span>
                        <span className='descsmall'>Items like <strong>tools/resources</strong> and <strong>valued opinions</strong> show <strong>low impact</strong>, indicating these are not priority levers for driving engagement.</span>
                    </Col>
                    <img src={thirdImage} alt='thirdImage'/>
                </Row>
            </Col>
            <Col className='section' data-id='4'>
                <span className='title'>Correlation: Trust in Leadership vs. Engagement</span>
                <span className='desc'>Employees who trust leadership tend to feel more engaged</span>
                <Row className='container'>
                    <img src={fourthImage} alt='fourthImage'/>
                    <Col>
                        <span className='descsmall'>Pearson correlation coefficient (r) = 0.88</span>
                        <span className='descsmall'>p-value = 0.0007</span>
                        <span className='descsmall'>There is a strong positive correlation between 'Trust in Leadership' and 'Overall Engagement'.</span>
                        <span className='descsmall'>Employees who trust leadership tend to feel more engaged.</span>
                        <span className='descsmall'>Business implication: To improve engagement, build leadership trust via clear communication, transparency, and visible decision-making.</span>
                    </Col>
                </Row>
            </Col>
            <Col className='section' data-id='5'>
                <span className='title'>Hypothesis testing</span>
                <span className='desc'>No statistically significant differences were found in how men and women rated the selected drivers.</span>
                <Row className='container'>
                    <img src={fifthImage} alt='fifthImage'/>
                    <Col>
                        <span className='descsmall'>This suggests a <strong>gender-balanced experience</strong> across key drivers. While men rate <strong>Manager Support</strong> slightly higher on average, the differences aren't large or statistically meaningful.</span>
                        <span className='descsmall'>This indicates a <strong>broadly equitable environment</strong>, though deeper dives into specific roles or functions may uncover nuances.</span>
                    </Col>
                </Row>
                <GRID>
                    <span className='descsmall bold'>Driver</span>
                    <span className='descsmall bold'>Men</span>
                    <span className='descsmall bold'>Women</span>
                    <span className='descsmall bold'>P-Value</span>
                    <span className='descsmall bold'>Insights</span>
                    <span className='descsmall left'>Recognition</span>
                    <span className='descsmall'>3.46</span>
                    <span className='descsmall'>3.49</span>
                    <span className='descsmall'>0.79</span>
                    <span className='descsmall left'>Both genders feel equally recognized.</span>
                    <span className='descsmall left'>Manager Support</span>
                    <span className='descsmall'>3.93</span>
                    <span className='descsmall'>3.77</span>
                    <span className='descsmall'>0.086</span>
                    <span className='descsmall left'>Slight lean toward males rating support higher, but not significant.</span>
                    <span className='descsmall left'>Trust in Leadership</span>
                    <span className='descsmall'>3.49</span>
                    <span className='descsmall'>3.57</span>
                    <span className='descsmall'>0.42</span>
                    <span className='descsmall left'>Minor difference; trust is similarly rated.</span>
                </GRID>
            </Col>
        </Col>
    )
}